import React, { useState } from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import feeImage from "../assets/admission/1.jpg";
import formImage from "../assets/admission/2.jpg";
import registrationImage from "../assets/admission/3.jpg";
import booksImage from "../assets/admission/4.jpg";
import books1Image from "../assets/admission/5.jpg";
import books2Image from "../assets/admission/6.jpg";
import books3Image from "../assets/admission/7.jpg";

const Admission = () => {
    const [open, setOpen] =
        useState(false);

    return (
        <>
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <div className="w-full bg-[#f5f5f5] min-h-screen">

                {/* SUB MENU */}
                <div className="sticky top-0 z-40 bg-[#d89f12] shadow-md">

                    <div className="max-w-7xl mx-auto px-4">

                        <div className="flex flex-wrap items-center gap-4 md:gap-7 py-4 text-white text-sm md:text-base font-medium overflow-x-auto">

                            <a
                                href="#admission"
                                className="whitespace-nowrap hover:text-[#072F5F] transition-all duration-300 border-r border-white pr-5"
                            >
                                Admission
                            </a>

                            <a
                                href="#procedure"
                                className="whitespace-nowrap hover:text-[#072F5F] transition-all duration-300 border-r border-white pr-5"
                            >
                                Admission Procedure
                            </a>

                            <a
                                href="#discipline"
                                className="whitespace-nowrap hover:text-[#072F5F] transition-all duration-300 border-r border-white pr-5"
                            >
                                Discipline
                            </a>

                            <a
                                href="#rules"
                                className="whitespace-nowrap hover:text-[#072F5F] transition-all duration-300 border-r border-white pr-5"
                            >
                                School Rules
                            </a>

                            <a
                                href="#fees"
                                className="whitespace-nowrap hover:text-[#072F5F] transition-all duration-300"
                            >
                                School Fees
                            </a>

                        </div>

                    </div>

                </div>

                {/* MAIN CONTENT */}
                <div className="max-w-6xl mx-auto px-5 md:px-10 py-14">

                    {/* ADMISSION */}
                    <section
                        id="admission"
                        className="scroll-mt-28"
                    >

                        <div className="bg-[#f8f6e8] rounded-[20px] shadow-md border border-[#e3dcc0] overflow-hidden">

                            {/* TOP HEADER */}
                            <div className="bg-[#072F5F] px-6 md:px-10 py-5">

                                <h2 className="text-3xl md:text-4xl font-bold text-white">

                                    Admission

                                </h2>

                            </div>

                            {/* ADMISSION DOCUMENT IMAGES */}
                            <div className="mb-12">

                                <div className="flex flex-col">

                                    {/* FEES IMAGE */}
                                    <div className="w-full">

                                        <img
                                            src={feeImage}
                                            alt="Admission Fees"
                                            className="w-full block"
                                        />

                                    </div>

                                    {/* FORM IMAGE */}
                                    <div className="w-full">

                                        <img
                                            src={formImage}
                                            alt="Admission Form"
                                            className="w-full block"
                                        />

                                    </div>

                                    {/* REGISTRATION IMAGE */}
                                    <div className="w-full">

                                        <img
                                            src={registrationImage}
                                            alt="Registration Form"
                                            className="w-full block"
                                        />

                                    </div>

                                    {/* BOOK LIST IMAGE */}
                                    <div className="w-full">

                                        <img
                                            src={booksImage}
                                            alt="Book List"
                                            className="w-full block"
                                        />

                                    </div>

                                    {/* BOOK LIST IMAGE 2 */}
                                    <div className="w-full">

                                        <img
                                            src={books1Image}
                                            alt="Book List"
                                            className="w-full block"
                                        />

                                    </div>

                                    {/* BOOK LIST IMAGE 3 */}
                                    <div className="w-full">

                                        <img
                                            src={books2Image}
                                            alt="Book List"
                                            className="w-full block"
                                        />

                                    </div>

                                    {/* BOOK LIST IMAGE 4 */}
                                    <div className="w-full">

                                        <img
                                            src={books3Image}
                                            alt="Book List"
                                            className="w-full block"
                                        />

                                    </div>

                                </div>

                            </div>

                            {/* CONTENT */}
                            <div className="px-5 md:px-12 py-10 text-[#4a4a4a]">

                                {/* PROCEDURE */}
                                <div className="mb-10">

                                    <h3 className="text-2xl italic font-bold text-[#5b5b5b] mb-5">

                                        Procedure for Admission

                                    </h3>

                                    <div className="space-y-5 leading-8 text-[17px]">

                                        <p>
                                            Parents / guardians should register their
                                            children/wards on the application form
                                            enclosed at the end of this prospectus.
                                            All the requirements mentioned in the
                                            Application form must be strictly
                                            followed. Admission is purely on the
                                            basis of merit list prepared after the
                                            entrance test followed by a personal
                                            interview provided there is a seat
                                            vacant.
                                        </p>

                                        <p>
                                            The school has classes from Nursery
                                            to Class: X
                                        </p>

                                    </div>

                                </div>

                                {/* NURSERY */}
                                <div className="mb-10">

                                    <h3 className="text-2xl italic font-bold text-[#5b5b5b] mb-4">

                                        Admission to Nursery / Play way Class:

                                    </h3>

                                    <div className="border-t border-gray-400 mb-6"></div>

                                    <h4 className="text-xl italic font-bold text-[#5b5b5b] mb-5">

                                        Eligibility:

                                    </h4>

                                    <div className="space-y-5 leading-8 text-[17px]">

                                        <p>
                                            Age should be between 2.6 and
                                            three years as on March 31 of
                                            the academic session in which
                                            the child seeks admission to
                                            class Nursery.
                                        </p>

                                        <p>
                                            The candidates along with their
                                            parents are called for a school
                                            visit to interact with the
                                            teachers.
                                        </p>

                                        <p>
                                            Short Listed candidates are
                                            forwarded to the admission
                                            committee. The committee
                                            comprises of Principal,
                                            Vice-Principal, In-charge
                                            Pre-Primary.
                                        </p>

                                    </div>

                                </div>

                                {/* KG */}
                                <div className="mb-10">

                                    <h3 className="text-2xl font-bold text-[#5b5b5b] mb-5">

                                        Admission to K.G. and other classes:

                                    </h3>

                                    <div className="space-y-5 leading-8 text-[17px]">

                                        <p>
                                            An oral interaction with the
                                            child is conducted for the
                                            classes K.G. and 1
                                        </p>

                                        <p>
                                            Written assessment is conducted
                                            for the classes 2 to 9 on the
                                            basis of the prescribed syllabus
                                            for the admission to that
                                            particular class.
                                        </p>

                                        <p>
                                            Students who qualify the written
                                            and oral test are called for an
                                            interaction with the Principal
                                            subsequently. The applicant must
                                            be accompanied by the parents.
                                        </p>

                                        <p>
                                            Admission is granted according
                                            to the merit list prepared on
                                            basis of the performance of the
                                            student in the written test and
                                            the interaction.
                                        </p>

                                    </div>

                                </div>

                                {/* NOTE */}
                                <div className="mb-10">

                                    <h3 className="text-2xl italic font-bold text-[#5b5b5b] mb-5">

                                        Note:

                                    </h3>

                                    <div className="space-y-5 leading-8 text-[17px]">

                                        <p>
                                            Peoples who have attended other
                                            school cannot be admitted until
                                            Transfer Certificate from
                                            previous school is submitted.
                                        </p>

                                        <p>
                                            Based on admission and other
                                            criteria, the school reserves
                                            the right to admit students who
                                            are found to be fit for
                                            admission.
                                        </p>

                                        <p>
                                            In all matters related to
                                            admissions, the management's
                                            decision is final.
                                        </p>

                                    </div>

                                </div>

                                {/* REQUIREMENT */}
                                <div className="mb-10">

                                    <h3 className="text-2xl italic font-bold text-[#5b5b5b] mb-5">

                                        Requirement for Admission

                                    </h3>

                                    <ol className="list-decimal pl-8 space-y-4 leading-8 text-[17px]">

                                        <li>
                                            Countersigned TC / Date of
                                            Birth Certificate
                                        </li>

                                        <li>
                                            Attested copy of the Mark Sheet
                                        </li>

                                        <li>
                                            Conduct Certificate
                                        </li>

                                        <li>
                                            Four passport size photographs
                                        </li>

                                    </ol>

                                </div>

                                {/* FINAL NOTE */}
                                <div className="mb-10">

                                    <h3 className="text-2xl italic font-bold text-[#5b5b5b] mb-5">

                                        Note:

                                    </h3>

                                    <div className="space-y-4 leading-8 text-[17px]">

                                        <p>
                                            Registration does not guarantee
                                            admissions.
                                        </p>

                                        <p>
                                            The registration fee is neither
                                            transferable nor refundable.
                                        </p>

                                    </div>

                                </div>

                                {/* TABLE */}
                                <div className="mt-12 overflow-x-auto">

                                    <div className="border-t border-gray-400 mb-5"></div>

                                    <h3 className="text-center font-bold text-[#5b5b5b] text-xl mb-6">

                                        The age at the time of admission
                                        to various classes should
                                        ordinarily not exceed:

                                    </h3>

                                    {/* TABLE */}
                                    <div className="mt-14 overflow-x-auto">

                                        <div className="w-full flex justify-center">

                                            <table className="w-full max-w-4xl border-2 border-black border-collapse table-fixed bg-white shadow-sm">

                                                <thead className="bg-[#d89f12] text-black">

                                                    <tr>

                                                        <th className="w-1/4 border border-black py-4 px-2 text-lg font-bold">
                                                            CLASS
                                                        </th>

                                                        <th className="w-1/4 border border-black py-4 px-2 text-lg font-bold">
                                                            AGE
                                                        </th>

                                                        <th className="w-1/4 border border-black py-4 px-2 text-lg font-bold">
                                                            CLASS
                                                        </th>

                                                        <th className="w-1/4 border border-black py-4 px-2 text-lg font-bold">
                                                            AGE
                                                        </th>

                                                    </tr>

                                                </thead>

                                                <tbody className="bg-[#fafafa]">

                                                    <tr>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            Nursery / Play
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            3
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            4
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            9
                                                        </td>

                                                    </tr>

                                                    <tr>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            LKG
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            4
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            5
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            10
                                                        </td>

                                                    </tr>

                                                    <tr>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            UKG
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            5
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            6
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            11
                                                        </td>

                                                    </tr>

                                                    <tr>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            1
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            6
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            7
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            12
                                                        </td>

                                                    </tr>

                                                    <tr>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            2
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            7
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            8
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            13
                                                        </td>

                                                    </tr>

                                                    <tr>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            3
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            8
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            9
                                                        </td>

                                                        <td className="border border-black py-4 px-3 text-center text-lg">
                                                            14
                                                        </td>

                                                    </tr>

                                                </tbody>

                                            </table>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </section>

                    {/* PROCEDURE */}
                    <section
                        id="procedure"
                        className="scroll-mt-28 mt-12"
                    >

                        <div className="bg-white rounded-[30px] shadow-lg overflow-hidden border border-gray-100">

                            <div className="bg-[#d89f12] px-6 md:px-10 py-7">

                                <h2 className="text-3xl md:text-4xl font-bold text-white">

                                    Procedure for Admission

                                </h2>

                            </div>

                            <div className="p-6 md:p-10">

                                <ul className="space-y-5 text-gray-700 text-lg leading-9 list-disc pl-5">

                                    <li>
                                        Parents / guardians should register their children/wards on the application form enclosed at the end of this prospectus. All the requirements mentioned in the Application form must be strictly followed. Admission is purely on the basis of merit list prepared after the entrance test followed by a personal interview provided there is a seat vacant.
                                    </li>

                                    <li>
                                        The school has classes from Nursery to Class: X
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </section>

                    {/* DISCIPLINE */}
                    <section
                        id="discipline"
                        className="scroll-mt-28 mt-12"
                    >

                        <div className="bg-white rounded-[30px] shadow-lg overflow-hidden border border-gray-100">

                            <div className="bg-[#072F5F] px-6 md:px-10 py-7">

                                <h2 className="text-3xl md:text-4xl font-bold text-white">

                                    General Discipline

                                </h2>

                            </div>

                            <div className="p-6 md:p-10">

                                <ul className="space-y-5 text-gray-700 text-lg leading-9 list-disc pl-5">

                                    <li>
                                        Great care is taken to form the character of pupils, to inspire them with a love of religion and morality, to help them become against of needed social change in the country trend and to be gentlemen and women and acquire habits of the cleanliness and order, prepare them to be good and loyal citizen of India.
                                    </li>

                                    <li>
                                        Monthly reports will keep parents informed of the behavior and diligence of their children. These reports have to be signed by the parents and returned to the class teacher for verification.
                                    </li>

                                    <li>
                                        Reports on general progress are given at the end of each term.
                                    </li>

                                    <li>
                                        Pupil whose conduct is injurious to the moral tone of the school or incompatible with strict discipline is liable to be dismissed. In particular, stealing and cheating will be dealt very sternly. Whose presence in the opinion of the Principal is not beneficial or whose application is unsatisfactory or whose parents show little interest in their progress will be requested to be withdrawn.
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </section>

                    {/* RULES */}
                    <section
                        id="rules"
                        className="scroll-mt-28 mt-12"
                    >

                        <div className="bg-white rounded-[30px] shadow-lg overflow-hidden border border-gray-100">

                            <div className="bg-[#d89f12] px-6 md:px-10 py-7">

                                <h2 className="text-3xl md:text-4xl font-bold text-white">

                                    School Rules

                                </h2>

                            </div>

                            <div className="p-6 md:p-10">

                                <ul className="space-y-5 text-gray-700 text-lg leading-9 list-disc pl-5">

                                    <li>
                                        Students must come punctually to the school 15 minutes before the school time in clean, tidy and in school uniform. Otherwise he / she will not be allowed to sit in the classes and are liable to be sent home.
                                    </li>

                                    <li>
                                        During class time no pupil is allowed to leave the school compound without proper permission from the Principal.
                                    </li>

                                    <li>
                                        Class will begin at prescribed time. Parents must make sure that their children reach the school 5 minutes before the class begins.
                                    </li>

                                    <li>
                                        Private tuition is discouraged while daily study, asking question in class and clarification of doubts in class are encouraged.
                                    </li>

                                    <li>
                                        For leave of absence previous sanction is to be obtained from the Principal in writing.
                                    </li>

                                    <li>
                                        Leave of absence during the term will not be granted except under very special circumstances.
                                    </li>

                                    <li>
                                        Request for leave on medical ground must be supported by a certificate of a registered medical practitioner. In this case the application must be forwarded at last on the second or third day of the leave.
                                    </li>

                                    <li>
                                        If any student is continuously absent from the school without any information for more than 15 days his / her name will strike off from the register.
                                    </li>

                                    <li>
                                        Parents should not visit the students without the permission of the Principal
                                    </li>

                                    <li>
                                        Guardians should see that their ward has done the hometask given to his / her daily.
                                    </li>

                                    <li>
                                        Students should not bring any costly articles or money to the school. The school authorities will in no way responsible for costly items brought to the school and lost.
                                    </li>

                                    <li>
                                        Parents should not visit the class teachers without the permission of the Principal.
                                    </li>

                                    <li>
                                        No student will be allowed to remain for more than two years in the same class.
                                    </li>

                                    <li>
                                        Students may be required to attend extra classes on any working day after school hours or on holidays, provided they have been informed on the previous day. Students themselves must make the alternative for their conveyance etc., if necessary.
                                    </li>

                                    <li>
                                        Respect your elders and teachers wherever you meet them and greet them with respect and love.
                                    </li>

                                    <li>
                                        Before and after every class, stand up for prayer.
                                    </li>

                                    <li>
                                        No books, magazines, comics etc. other than those provided by the school, will be allowed in the hands of pupils unless signed by the Principal.
                                    </li>

                                    <li>
                                        No child is allowed to bring mobile phone to the school. Using mobile phone in the school premises is strictly prohibited.
                                    </li>

                                    <li>
                                        No exemption shall be given from the school programmes and functions. Every student is supposed to take part and co-operate in the various school activities such as cultural programmes, sports and games, drill etc.
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </section>

                    {/* FEES */}
                    <section
                        id="fees"
                        className="scroll-mt-28 mt-12"
                    >

                        <div className="bg-white rounded-[30px] shadow-lg overflow-hidden border border-gray-100">

                            <div className="bg-[#072F5F] px-6 md:px-10 py-7">

                                <h2 className="text-3xl md:text-4xl font-bold text-white">

                                    School Fees

                                </h2>

                            </div>

                            <div className="p-6 md:p-10">

                                <ul className="space-y-5 text-gray-700 text-lg leading-9 list-disc pl-5">

                                    <li>
                                        Admission fee includes Infra structure development, General Maintenance of the school etc.
                                    </li>

                                    <li>
                                        Special fee includes Generator running, Electricity etc.
                                    </li>

                                    <li>
                                        Activity fee includes Prizes and Awards, Cultural Activities, Festivals and Occasions etc.
                                    </li>

                                    <li>
                                        School Tuition Fees are charged in full for all 12 months.
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </section>

                </div>

            </div>

            <Footer />
        </>
    );
};

export default Admission;